/**
 * Axis scaling, matching viscom_liner.
 *
 * The desktop uses NO custom tick logic: SciChart's default provider picks a
 * major delta of 1/2/5 x 10^n and fits at most MaxAutoTicks of them. The web
 * client already has that provider — what it lacked was the budget, and in one
 * place it had been overridden outright with a fixed 20 m interval, which gave
 * two labels on a short liner and forty on a long one.
 *
 * So the equivalent is not an algorithm to write but one to stop bypassing.
 *
 * Ranges are data-driven, as on the desktop:
 *   LENGTH        [0, dataSetWidth], or the liner bounds when set
 *   TEMPERATURE   auto-range to data
 *   TIME          auto-range to data
 *
 * Units are a LABEL concern only — the domain stays unit-agnostic and the
 * metric/imperial choice is applied in labelPostfix, never to the values.
 */

/** SciChart's MaxAutoTicks, matching viscom_liner's default. */
export const MAX_AUTO_TICKS = 10;

/** Decimal places on length and temperature labels: '{:F2}m', '{:F2}°C'. */
export const LABEL_PRECISION = 2;
